import { useValue } from '@morningtrain/react-resources'

export default function Integer ({ name, defaultValue = null }) {
  const value = useValue(name, defaultValue)

  const valueAsInt = parseFloat(value)

  return isNaN(valueAsInt) ? 0 : Math.round(valueAsInt).toLocaleString()
}
